import styled from 'styled-components';

export const PontoContainer = styled.div`
  margin-bottom: 10px;
`;
